<template>
  <block>
    <div class="benefits__icons">
      <div class="benefits__icons-item" v-for="(item, index) in benefits" :key="item.title + index"
        @click="viewBenefits(index)">
        <img class="benefits__icon" :src="item.icon" />
        <span class="benefits__desc">{{ item.title }}</span>
      </div>
    </div>
  </block>
</template>
<script>

export default {
  props: {
    benefits: {
      type: Array,
      value: [],
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isToggle: false,
    };
  },
  computed: {
  },
  methods: {
    viewBenefits(index) {
      this.$router.push({
        path: '/personalCenter/benefits',
        query: {
          activeTab: 30,
          index,
          hiddenNavigationBar: 1,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '../../../member/index.scss';

.benefits__icons {
  display: flex;
  flex-wrap: wrap;
  padding: 26px 38px 36px;

  &-item {
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 22px;
  }

  .benefits__icon {
    width: 72px;
    height: 72px;
  }

  .benefits__desc {
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;

    color: #333333;
    text-align: center;
    margin-top: 10px;
  }
}
</style>
